// Vendor
import * as React from 'react';

// Vendor Components
import {CircularProgress, CircularProgressProps} from 'material-ui/Progress';

// Shared Components
import CenteredContent from 'isee/ui/components/centered-content';
import PaddedContent from 'isee/ui/components/padded-content';

// Utils
import {debounce} from 'isee/utils/debounce';

// Types
interface Props extends CircularProgressProps {
  padding?: number;
  delayMS?: number;
}

interface State {
  isPastDelay: boolean;
}

const noop = () => {};

class CenteredSpinner extends React.Component<Props, State> {
  public readonly state: Readonly<State> = {
    isPastDelay: false
  };

  private cancelShowSpinner = noop;
  private showSpinner = debounce(this.props.delayMS || 0, () =>
    this.setState({isPastDelay: true})
  );

  public componentDidMount() {
    this.cancelShowSpinner = this.showSpinner();
  }

  public componentWillUnmount() {
    this.cancelShowSpinner();
  }

  public render() {
    const {isPastDelay} = this.state;
    const {padding = 0, size = 50, delayMS: _delayMS, ...props} = this.props;

    if (!isPastDelay) return null;

    return (
      <CenteredContent>
        <PaddedContent size={padding}>
          <CircularProgress size={size} {...props} />
        </PaddedContent>
      </CenteredContent>
    );
  }
}

export default CenteredSpinner;



// WEBPACK FOOTER //
// ./src/ui/components/centered-spinner/centered-spinner.tsx